import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function FailedAttempts() {
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-74">
      <div className="max-w-4xl mx-auto px-4" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-76">
          <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436] text-center mb-4" data-id="element-77">
            ¿Por qué lo que has intentado no funciona?
          </h2>
          <p className="text-center text-[#2D3436]/60 mb-12 max-w-2xl mx-auto" data-id="element-78">
            Estos métodos populares en realidad empeoran la inflamación
            abdominal después de los 30
          </p>

          <div className="space-y-4" data-id="element-79">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-80">
              <div className="flex items-start gap-4" data-id="element-81">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-82">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-83" />
                </div>
                <div data-id="element-84">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-85">
                    Las dietas de 1,200 calorías
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-86">
                    Elevan tu estrés metabólico y bloquean la digestión. Tu
                    cuerpo entra en modo de supervivencia y retiene todo lo que
                    puede.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-87">
              <div className="flex items-start gap-4" data-id="element-88">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-89">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-90" />
                </div>
                <div data-id="element-91">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-92">
                    El ejercicio de alto impacto (HIIT/Running)
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-93">
                    Dispara tus picos de cortisol después de los 30. Lo que
                    antes te ayudaba, ahora trabaja en tu contra.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-94">
              <div className="flex items-start gap-4" data-id="element-95">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-96">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-99">
                    Los batidos "detox" comerciales
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-100">
                    Están llenos de edulcorantes que irritan tu intestino y
                    aumentan la hinchazón en lugar de reducirla.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white rounded-2xl p-6 shadow-sm border-l-4 border-[#E17055]" data-id="element-101">
              <div className="flex items-start gap-4" data-id="element-102">
                <div className="flex-shrink-0 w-10 h-10 bg-[#E17055]/10 rounded-full flex items-center justify-center" data-id="element-103">
                  <XIcon className="w-5 h-5 text-[#E17055]" data-id="element-104" />
                </div>
                <div data-id="element-105">
                  <h3 className="font-semibold text-[#2D3436] text-lg mb-2" data-id="element-106">
                    Dormir poco
                  </h3>
                  <p className="text-[#2D3436]/70" data-id="element-107">
                    Anula cualquier esfuerzo que hagas en la cocina durante el
                    día. Sin descanso adecuado, tu cuerpo no puede
                    desinflamarse.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}